<template>
    <div>
        <header>
            <h4>Your portal is ready.</h4>
        </header>

        <p><br />We've sent you a link to your portal. Please check your email and click on the link to log in.</p>
        <p>Please contact us at <a href="mailto:hello@upskillenterprise.com">hello@upskillenterprise.com</a> if you did not receive a link or have issues logging in.</p>
    </div>
</template>

<script>
export default {
};
</script>

<style lang="scss">

</style>
